import Alpine from 'alpinejs';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
import { store } from './alpine/store';
import { createHeader } from './components/Header';
import { createDrawer } from './components/Drawer';
import { createDialog } from './components/Dialog';
import { createHero } from './components/Hero';
import { createTestimonials } from './components/Testimonials';
import { createCards } from './components/Cards';
import { createAnimated } from './components/Animated';
import ClipboardJS from "clipboard";

const gsapSetup = () => {
	/**
	 * Scroll to plugin setup.
	 *
	 * @see https://greensock.com/scrolltoplugin/
	 */
	gsap.registerPlugin(ScrollToPlugin);

	/**
	 * Scroll trigger plugin setup.
	 *
	 * @see https://greensock.com/docs/v3/GSAP/gsap.registerPlugin()
	 * @see https://greensock.com/docs/v3/Plugins/ScrollTrigger
	 */
	gsap.registerPlugin(ScrollTrigger);

	ScrollTrigger.defaults({
		start: 'top 100%',
     	end: 'bottom top',
		toggleActions: 'play play play play',
		refreshPriority: 1,
	});

	/**
	 * Timescale global timeline update.
	 *
	 * @description for prefers reduced motion increase timescale so animations do not play.
	 *
	 * @see https://greensock.com/docs/v3/GSAP/gsap.globalTimeline
	 * @see https://greensock.com/docs/v3/GSAP/Timeline/timeScale()
	 */
	gsap.globalTimeline.timeScale(1000);
	gsap.matchMedia().add('(prefers-reduced-motion: reduce)', () => {
		gsap.globalTimeline.timeScale(10000);
	});
}

document.addEventListener('alpine:init', () => {
	Alpine.data('store', store);
});

window.addEventListener('DOMContentLoaded', () => {
	gsapSetup();

	/* createHeader(); */
	createDrawer();
	createDialog();
	createHero();
	createTestimonials();
	createCards();
	createAnimated();

	Alpine.start();

	// Other
	if (document.querySelector('.select2')) {
		jQuery('.select2').select2();
	}

	new ClipboardJS("[data-clipboard-text]");
});
